import React, { useState, useEffect, } from "react";
import { FormattedMessage, } from "react-intl";
import Spinner from "../../../components/Spinner";
import { Row, Card, Button, Col, Descriptions, Tag, Alert, } from 'antd';
import notification from '../../../services/notification';
import { Pen, User, Bank, UsersThree, } from "@phosphor-icons/react";
import { StatusBadge, } from './../../../components/helpers';
import { EditUserModal, } from '../../../components/users';
import CustomerEditModal from '../../customers/modal/customer.edit.modal';
import { CustomerDetails, } from '../../../services/customer';
import { COUNTRIES, } from "../../../constants/countries";

/*
Profile details based on the difrent profile types:
DEALER, CONSUMER, COMPANY
*/
const ProfileCustomerView = ({
    history,
    ...props
}) => {

    const [userProfileData, setUserProfileData] = useState({});
    const [customerData, setcustomerData] = useState({});
    const [detailsLoading, setDetailsLoading] = useState(true);

    // Modals
    const [editCustomerOpen, setEditCustomerOpen] = useState(false);
    const [editUserOpen, setEditUserOpen] = useState(false);


    useEffect(() => {
        LoadCustomerDetails();

        return () => {
            // cleanup
            setUserProfileData({});
            setcustomerData({});
            setDetailsLoading(true);
        }
        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const LoadCustomerDetails = () => {
        setDetailsLoading(true);

        // now get the company details
        CustomerDetails("me", history)
            .then(response => {
                if (response.status) {
                    setcustomerData(response.data);
                    setDetailsLoading(false);
                }
                else {
                    history('/dashboard');
                    console.error('error:', response)
                    notification['warning']({
                        message: 'Customer details',
                        description: "Error on requesting Customer data",
                    });

                }
            })
            .catch(error => {
                console.error('error: ', error);
            });
    };


    if (detailsLoading) return <Spinner />;

    return (

        <React.Fragment>

            <Row gutter={[32, 32]}>
                <Col span={24}>

                    {/* Customer detail card */}
                    <Card
                        title={<h4 className="card-title"><FormattedMessage id="customer-details" /></h4>}
                        className="my-4"
                        extra={[
                            <Button
                                key="edit"
                                onClick={() => { setEditCustomerOpen(!editCustomerOpen) }}
                                icon={<Pen size={16} />}>
                                <FormattedMessage id="edit" />
                            </Button>
                        ]}>

                        <Descriptions bordered column={1}>
                            <Descriptions.Item label={<FormattedMessage id="status" />}>
                                <StatusBadge status={customerData.customer_status} />
                            </Descriptions.Item>
                            <Descriptions.Item label={<FormattedMessage id="type" />}>
                                <Tag color={customerData.customer_type === 'COMPANY' ? 'green' : customerData.customer_type === 'DEALER' ? 'volcano' : 'geekblue'}>
                                    {customerData.customer_type === 'COMPANY' ? <Bank size={16} weight="light" className="mr-1" /> : customerData.customer_type === 'DEALER' ? <UsersThree size={16} weight="light" className="mr-1" /> : <User size={16} weight="light" className="mr-1" />}
                                    <FormattedMessage id={customerData.customer_type.toUpperCase()} />
                                </Tag>


                                {/* <Tag color={customerData.customer_type === 'COMPANY' ? 'green' : 'geekblue'}>
                                {customerData.customer_type === 'COMPANY' ? <Bank size={16} weight="light" className="mr-1" /> : <User size={16} className="mr-1" />}
                                {customerData.customer_type?.toUpperCase()}
                            </Tag> */}
                            </Descriptions.Item>

                            {(customerData.customer_type === 'COMPANY' || customerData.customer_type === "DEALER") ? (
                                <>
                                    <Descriptions.Item label={<FormattedMessage id="company-name" />}>{customerData.customer_name}</Descriptions.Item>
                                    <Descriptions.Item label={<FormattedMessage id="company-registration-number" />}>{customerData?.customer_data?.customer_registration_number}</Descriptions.Item>
                                    <Descriptions.Item label={<FormattedMessage id="company-vat-number" />}>{customerData?.customer_data?.customer_vat_number}</Descriptions.Item>
                                </>
                            ) : (
                                <Descriptions.Item label={<FormattedMessage id="customer-name" />}>{customerData.customer_name}</Descriptions.Item>
                            )}
                        </Descriptions>
                    </Card>

                    {/* address details */}
                    <Card
                        title={<h4 className="card-title"><FormattedMessage id="customer-details-address" /></h4>}
                        className="my-4"
                        extra={[
                            <Button
                                key="edit"
                                onClick={() => { setEditCustomerOpen(!editCustomerOpen) }}
                                icon={<Pen size={16} />}>
                                <FormattedMessage id="edit" />
                            </Button>
                        ]}>

                        <Descriptions bordered column={1}>
                            <Descriptions.Item label={<FormattedMessage id="customer-street-number" />}>{customerData?.customer_data?.customer_address?.street_number}</Descriptions.Item>
                            <Descriptions.Item label={<FormattedMessage id="customer-zip-city" />}>{customerData?.customer_data?.customer_address?.zip_code} {customerData?.customer_data?.customer_address?.city}</Descriptions.Item>
                            <Descriptions.Item label={<FormattedMessage id="country" />}>{COUNTRIES.find(item => item.id === (customerData?.customer_data?.customer_address?.country || 'nl'))?.name}</Descriptions.Item>
                        </Descriptions>
                    </Card>


                    {/* common contact details */}
                    <Card
                        title={<h4 className="card-title"><FormattedMessage id="common-contact-details" /></h4>}
                        className="my-4"
                        extra={[
                            <Button
                                key="edit"
                                onClick={() => { setEditCustomerOpen(!editCustomerOpen) }}>
                                <Pen size={16} className="mr-1" /> <FormattedMessage id="edit" />
                            </Button>
                        ]}>

                        <Alert
                            showIcon
                            className="my-2"
                            title={<FormattedMessage id="common-contact-details-info" />} />

                        <Descriptions bordered column={1}>
                            <Descriptions.Item label={<FormattedMessage id="phonenumber" />}>{customerData?.customer_data?.customer_contact_data?.customer_phone_number}</Descriptions.Item>
                            <Descriptions.Item label={<FormattedMessage id="emailaddress" />}>{customerData?.customer_data?.customer_contact_data?.customer_email}</Descriptions.Item>
                            <Descriptions.Item label={<FormattedMessage id="preference-language" />}>{customerData?.customer_data?.customer_contact_data?.customer_preference_language}</Descriptions.Item>
                        </Descriptions>
                    </Card>

                </Col>
            </Row>

            {editUserOpen && (
                <EditUserModal
                    modalIsOpen={editUserOpen}
                    modalIsOpenHandler={setEditUserOpen}
                    userProfileData={userProfileData}
                    refreshData={LoadCustomerDetails}
                    history={history}
                    {...props}
                />
            )}

            {editCustomerOpen && (
                <CustomerEditModal
                    modalIsOpen={editCustomerOpen}
                    modalIsOpenHandler={setEditCustomerOpen}
                    customerData={customerData}
                    refreshData={LoadCustomerDetails}
                    history={history}
                    {...props} />
            )}




        </React.Fragment>

    );
};

export default ProfileCustomerView;